export const SEARCHKIT_LISTEN: string = "SEARCHKIT_LISTEN";
export const SEARCHKIT_UNLISTEN: string = "SEARCHKIT_UNLISTEN";
export const SEARCHKIT_UPDATE: string = "SEARCHKIT_UPDATE";
export const SEARCHKIT_CHANGE_URL: string = "SEARCHKIT_CHANGE_URL";
export const SEARCHKIT_CHANGE_INDEX: string = "SEARCHKIT_CHANGE_INDEX";
